export default __webpack_public_path__ + "static/media/grid-alt.70f54df6.svg";